export default __webpack_public_path__ + "static/media/empty-state.95c29aeb.png";